module.exports = __webpack_public_path__ + "static/media/SF-Pro-Text-Bold.3abde616.otf";